import React from "react";

import { DocScanSource, DocScanUser } from "models";

import { Flex, TagNormal, TooltipWrapper, Typography } from "components";

const SOURCES: Record<DocScanSource, { label: string; color: string }> = {
  manualUpload: { label: "Manual", color: "blue" },
  verificationTaskUpload: { label: "Task upload", color: "indigo" },
  backfill: { label: "Backfill", color: "grey-600" },
};

export const DocScanSourceTag = ({ source }: { source: DocScanSource }) => <TagNormal text={SOURCES[source].label} color={SOURCES[source].color} />;

type DocScanTriggeredByProps = {
  source: DocScanSource;
  isAdmin: boolean;
  user?: DocScanUser | null;
};

export const DocScanTriggeredBy = ({ source, isAdmin, user }: DocScanTriggeredByProps) => {
  if (source === "backfill") return <TagNormal text="System" color="grey-600" />;

  const fullName = user ? `${user.firstName} ${user.lastName}` : "-";

  return (
    <Flex align="center" gap={8}>
      <TooltipWrapper tooltip={{ title: fullName, placement: "top" }}>
        <Typography variant="paragraph-m">{fullName}</Typography>
      </TooltipWrapper>
      <TagNormal className="doc-scan-role-tag" text={isAdmin ? "Admin" : "Farmer"} color={isAdmin ? "purple" : "green"} />
    </Flex>
  );
};
